import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASEURL || "https://velocity-self-drive-97051a5003ae.herokuapp.com/",
  headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    if (response) {
      if (response.status === 401) {
        console.error("Unauthorized access. Please log in.");
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(response.data);
      }
      const errorMessage = response.data?.message || "An error occurred";
      console.error("Error:", errorMessage);
      toast.error(errorMessage);
      return Promise.reject(response.data);
    } else {
      console.error("Network Error:", error.message);
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
